import React from 'react';
import FlipMove from 'react-flip-move';
import Event from '../../models/Event';
import './ChartContainer.css';
import { EventQuestionType } from '../../models/EventQuestionType';
import _ from 'lodash';
import Ideas from '../../models/Ideas';
import Media from '../../models/Media';
import EventStats from '../../models/EventStats';
import JustGage from 'webpack-justgage';
import Response from '../../models/Response';
import StackRankReportSummary from '../../components/creator-report/StackRankReportSummary'
import MultipleRatingReportSummary  from '../../components/creator-report/MultipleRatingReportSummary'

export class ChartContainer extends React.Component {

  getChart = () => {
    const { event, stats, ideas, onImageClick, padding, disableAnimation } = this.props;
    const type = Event.getQuestionType(event);
    if (EventQuestionType.isScaleType(type)) {
      return <Gauge event={ event } eventStats={ stats } disableAnimation={ disableAnimation } />;
    } else if (EventQuestionType.isBinaryType(type)) {
      return <YesNoColumns ideas={ ideas } />;
    } else if (EventQuestionType.isMultipleType(type)) {
      return <MultipleChoiceCards onImageClick={ onImageClick } ideas={ ideas } padding={ padding } disableAnimation={ disableAnimation } />;
    } else if (EventQuestionType.isMultipleRatingType(type)) {
      return <MultipleRatingReportSummary event={ event } ideas={ ideas } />;  // added by akmal
    } else if (EventQuestionType.isStackRankType(type)) {
      return <StackRankReportSummary event={ event } ideas={ ideas } />; // added by akmal
    } else {  // added by akmal for checking..
      console.log(`Unknown EventQuestionType: ${type}`);
      return <div>Displaying {type}</div>;
    } 
  };

  // Change this h-100 to my-auto if the chart ends up looking too big
  render () {
    const { event } = this.props;
    return (
      <div
        className={ `w-100 print-card-header page-break-avoid h-100` }
        style={ { flex: 'auto' } }
        key={ Event.getId(event) }>
        { this.getChart() }
      </div>
    );
  }
}

const VerticalProgressBar = ({ progress }) => (
  // 85 so this doesn't push out the labels above and below
  <div className="vprogressbar" style={ { height: `${ progress >= 100 ? 85 : progress }%` } }>
    <div className="vprogress bg-yellow rounded" />
  </div>
);

class ChoiceColumn extends React.Component {
  render () {
    const { idea } = this.props;
    const minFreq = 0.01; // so that the bars are always visible
    const freq = Ideas.getChoiceFrequency(idea);
    const hasFrequency = freq !== null && freq !== undefined;
    const progress = hasFrequency ? (freq + minFreq) * 100 : minFreq;
    return (
      <div
        className={`yesnocol col d-flex c-medium font-bold-title flex-column justify-content-end`}>
        <div className="text-center font-size-lg">{ Ideas.getChoicePercent(idea) || '0%' }</div>
        <VerticalProgressBar progress={ progress } />
        <div className="text-center font-size-xxl">{ Ideas.getName(idea) }</div>
      </div>
    );
  }
}

class YesNoColumns extends React.Component {
  render () {
    const { ideas } = this.props;
    return (
      <div className="yesnochartcontainer col d-flex flex-column m-auto">
        <div className="yesnocolumns row d-flex justify-content-around m-auto">
          { _.map(ideas, (idea) => (<ChoiceColumn idea={ idea } key={ Ideas.getId(idea) } />)) }
        </div>
      </div>
    );
  }
}

class Gauge extends React.Component {

  gauge = null;

  componentDidMount () {
    if (!this.gauge) {
      const { event, eventStats, disableAnimation } = this.props;
      const score = EventStats.getSimpleScore(eventStats);
      const maxScore = EventStats.getMaxScore(eventStats);
      const maxScoreText = EventStats.getMaxScoreDisplay(eventStats);
      const noScore = score === null || score === undefined;
      const otherTeal = '#3ED6DA';
      const otherColor = '#2BBEC3';
      const lightGrey = '#AFAFAF';
      const grey = '#909090';
      const teal = '#3D9AE2';
      // const labelText = noScore ? '' : 'Average';
      const labelText = 'Average';
      const fontSize = 15;
      this.gauge = new JustGage({
        id: Event.getId(event),
        decimals: 1,
        labelMinFontSize: fontSize,
        startAnimationType: 'bounce',
        refreshAnimationType: 'bounce',
        startAnimationTime: disableAnimation ? 0 : 700,
        refreshAnimationTime: disableAnimation ? 0 : 700,
        value: noScore ? 0 : score,
        min: 0,
        minTxt: 0,
        max: maxScore,
        maxTxt: maxScoreText,
        label: labelText, // TODO: figure out how to update this on gauge.refresh
        valueFontColor: grey,
        valueFontFamily: 'helvetica',
        levelColors: [otherTeal, otherColor, teal],
        gaugeColor: lightGrey,
        gaugeWidthScale: 0.6,
        labelFontColor: grey,
        hideValue: false, // TODO: figure out how to update this on gauge.refresh
        hideMinMax: false,
        counter: false, // if you set this to true the value always shows zero
        pointer: false,
        shadowOpacity: 0.5,
        shadowSize: 5,
        shadowVerticalOffset: 5,
        showInnerShadow: true,
        relativeGaugeSize: true
      });
    }
    this.updateGauge(this.props);
  }

  componentDidUpdate () {
    this.updateGauge(this.props);
  }

  componentWillReceiveProps (nextProps) {
    this.updateGauge(nextProps);
  }

  updateGauge = (props) => {
    if (!!this.gauge) {
      const { eventStats } = props;
      const score = EventStats.getSimpleScore(eventStats);
      const noScore = score === null || score === undefined;
      this.gauge.refresh(noScore ? 0 : score);
    }
  };

  render () {
    const { event } = this.props;
    return (
      <div className="gaugecontainer col flex-column d-flex justify-content-center m-auto">
       <div className="gaugewrapper row d-flex justify-content-center">
        <div className="gauge" id={ Event.getId(event) } />
       </div>
      </div>
    );
  }
}

const ProgressBar = ({ progress }) => (
  // subtract 15 so that text at the end of the bar doesn't get pushed to the next line ;)
  <div className="progressbar h-100" style={ { width: `${ progress >= 100 ? 90 : progress }%` } }>
    <div className="progress bg-yellow rounded" />
  </div>
);

class MultipleChoiceCards extends React.Component {

  render () {
    const { onImageClick, ideas, padding, disableAnimation } = this.props;
    const cardList = _.chain(ideas)
      .sortBy('choice_freq')
      .reverse()
      .map(idea => (
        <MultipleChoiceCard
          idea={ idea }
          onImageClick={ onImageClick }
          key={ `multiple-choice-card-${ Ideas.getId(idea) }` } />
      ))
      .value();

    if (disableAnimation) {
      return (
        <div className={ `multiplechoicerows col d-flex flex-column m-auto justify-content-center ${padding ? 'mccard-padding' : ''}` }>
          { cardList }
        </div>
      );
    }

    return (
      <FlipMove
        className={ `multiplechoicerows col d-flex flex-column m-auto justify-content-center ${padding ? 'mccard-padding' : ''}` }
        duration={ 1000 }
        delay={ 0 }
        easing={ 'cubic-bezier(0.39, 0, 0.45, 1.4)' }
        staggerDurationBy={ 22 }
        staggerDelayBy={ 0 }>
        { cardList }
      </FlipMove>
    );
  }

}

class MultipleChoiceCard extends React.Component {

  handleImageClick = ($event, photo) => {
    $event.preventDefault();

    const { onImageClick } = this.props;
    if (onImageClick) {
      onImageClick(photo);
    }
  };

  render () {
    const { idea } = this.props;
    const minFreq = 0.01; // so that the bars are always visible
    const freq = Ideas.getChoiceFrequency(idea);
    const hasFrequency = freq !== null && freq !== undefined;
    const progress = hasFrequency ? (freq + minFreq) * 100 : minFreq;
    const photoAttachment = Response.getPhotoAttachment(idea);

    let photo;
    if (photoAttachment) {
      photo = Media.getPhotoUrl(photoAttachment);
    } else {
      photo = null;
    }
    return (
      <div className="mccard mx-auto col d-flex flex-column c-medium font-bold-title">
        <div className="row font-size-xl label c-medium">{ Ideas.getName(idea) }</div>
        <div className="row mcpercentprogress">

          { !!photo && (
            <img
              onClick={ $e => this.handleImageClick($e, photo) }
              className="mr-3"
              width="96"
              height="96"
              src={ photo }
              alt={ Ideas.getName(idea) } />
          ) }

          <div className="col p-0">
            <ProgressBar progress={ progress } />
          </div>

          <div className="p-0 col-auto my-auto font-size-lg">
            { Ideas.getChoicePercent(idea) || '0%' }</div>
        </div>
      </div>
    );
  }
};
